import React from 'react'

import {SupportGroupCategory} from '@/api/models'
import DataTable from '@/common/data-table'
import useTableState from '@/common/data-table/use-table-state'
import {deleteAction, editAction} from '@/common/data-table/utils'
import DeleteResourceModal from '@/common/delete-resource-modal'
import useSupabaseQuery from '@/common/use-custom-query'
import useValueDisclosure from '@/common/use-value-disclosure'

import {columns, emptySupportGroupCaterogy, filterFields} from './constants'
import SupportGroupCategoryEditor from './editor-modal'

const SupportGroupCategories = () => {
  const tableState = useTableState({descending: true, sortBy: 'updated_at'})
  const {loading, data, fetch, rows} = useSupabaseQuery<SupportGroupCategory>({
    table: 'support_group_categories',
    fields: '*',
    pageNumber: tableState.page,
    descending: tableState.descending,
    itemsPerPage: tableState.rowsPerPage,
    order: tableState.sortBy.column as keyof SupportGroupCategory,
    filter: tableState.filter,
  })

  const {
    onClose: onDeleteClose,
    onOpen: onDeleteOpen,
    value: deleteValue,
  } = useValueDisclosure<SupportGroupCategory>()

  const {
    onClose: onEditorClose,
    onOpen: onEditorOpen,
    value: editorValue,
  } = useValueDisclosure<SupportGroupCategory>()

  const actions = React.useMemo(
    () => [editAction(onEditorOpen), deleteAction(onDeleteOpen)],
    [onDeleteOpen, onEditorOpen]
  )

  const handleAdd = React.useCallback(() => {
    onEditorOpen(emptySupportGroupCaterogy)
  }, [onEditorOpen])

  return (
    <>
      <DataTable<SupportGroupCategory>
        columns={columns}
        data={data ?? []}
        totalCount={rows}
        tableState={tableState}
        actions={actions}
        onRefresh={fetch}
        onAdd={handleAdd}
        loading={loading}
        filterFields={filterFields}
      />
      <SupportGroupCategoryEditor
        item={editorValue}
        open={!!editorValue}
        onClose={onEditorClose}
        onComplete={fetch}
      />
      <DeleteResourceModal
        table="support_group_categories"
        id={deleteValue?.id || ''}
        onClose={onDeleteClose}
        open={!!deleteValue}
        onComplete={fetch}
      />
    </>
  )
}

export default SupportGroupCategories
